'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _guessCountryFromDialCode = require('I18n/utils/guessCountryFromDialCode');

var _guessCountryFromDialCode2 = _interopRequireDefault(_guessCountryFromDialCode);

var _formatPhoneNumber = require('I18n/utils/formatPhoneNumber');

var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UITextInput = require('UIComponents/input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UISelect = require('UIComponents/input/UISelect');

var _UISelect2 = _interopRequireDefault(_UISelect);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _CountryFlag = require('../internal/components/CountryFlag');

var _CountryFlag2 = _interopRequireDefault(_CountryFlag);

var _getPhoneOptions = require('../internal/utils/getPhoneOptions');

var _getPhoneOptions2 = _interopRequireDefault(_getPhoneOptions);

var _SupportedPhoneNumbers = require('../constants/SupportedPhoneNumbers');

var _SupportedPhoneNumbers2 = _interopRequireDefault(_SupportedPhoneNumbers);

var _TelephoneData = require('I18n/constants/TelephoneData');

var TelephoneData = _interopRequireWildcard(_TelephoneData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var allCountries = TelephoneData.allCountries;
var iso2Lookup = TelephoneData.iso2Lookup;

var INVALID_OPTION = {
  dialCode: '',
  priority: 10001,
  iso2: null
};

exports.default = _react2.default.createClass({
  displayName: 'PhoneNumberInput',

  propTypes: {
    countrySelectProps: _react.PropTypes.object,
    extensionInputProps: _react.PropTypes.object,
    extensionValue: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    phoneInputProps: _react.PropTypes.object,
    supportedCountrySet: _react.PropTypes.oneOf(Object.keys(_SupportedPhoneNumbers2.default)),
    validCountries: _react.PropTypes.array,
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      countrySelectProps: {},
      extensionInputProps: {},
      phoneInputProps: {}
    };
  },
  getInitialState: function getInitialState() {
    return this._mapPropsToState(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.value === null || nextProps.value === undefined) {
      this.setState(this._mapPropsToState(nextProps));
    } else {
      var nextValueDigits = nextProps.value.replace(/\D/g, '');
      var currentValueDigits = this.state.formattedNumber.replace(/\D/g, '');
      if (nextProps.value && nextValueDigits !== currentValueDigits) {
        this.setState(this._mapPropsToState(nextProps));
      }
    }
  },
  _cursorToEnd: function _cursorToEnd() {
    var input = this.numberInput;
    if (input) {
      input.focus();
    }
  },
  formatSimpleNumber: function formatSimpleNumber(number) {
    var hasSelectedValidCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var digitsOnly = number.replace(/\D/g, '');
    if (!hasSelectedValidCountry) {
      return digitsOnly;
    }

    return '+' + digitsOnly;
  },
  handlePhoneNumberInput: function handlePhoneNumberInput(event) {
    var _state = this.state,
        formattedNumber = _state.formattedNumber,
        selectedCountry = _state.selectedCountry;

    var extension = this.props.extensionValue;
    var eventTarget = event.target;

    if (eventTarget.value === formattedNumber) {
      return;
    }

    var inputNumber = eventTarget.value.replace(/\D/g, '');
    if (inputNumber.indexOf(selectedCountry.dialCode) !== 0) {
      inputNumber = selectedCountry.dialCode;
    }

    if (this.props.onChange) {
      this.props.onChange({
        phoneNumber: this.formatSimpleNumber(inputNumber, selectedCountry.dialCode),
        extension: extension,
        country: selectedCountry.iso2
      });
    }

    var selectionStart = eventTarget.selectionStart;
    var formattedInputNumber = (0, _formatPhoneNumber2.default)(inputNumber, selectedCountry.format);

    this.setState({
      formattedNumber: formattedInputNumber
    }, function () {
      var newSelectionStart = selectionStart;
      if (inputNumber === selectedCountry.dialCode || selectionStart === formattedNumber.length + 1) {
        newSelectionStart = formattedInputNumber.length + 1;
      }

      eventTarget.selectionStart = newSelectionStart;
      eventTarget.selectionEnd = newSelectionStart;
    });
  },
  handleExtensionInput: function handleExtensionInput(e) {
    var _state2 = this.state,
        selectedCountry = _state2.selectedCountry,
        formattedNumber = _state2.formattedNumber;

    this.props.onChange({
      phoneNumber: this.formatSimpleNumber(formattedNumber, selectedCountry.dialCode),
      extension: e.target.value.replace(/\D/g, ''),
      country: selectedCountry.iso2
    });
  },
  handleFlagItemClick: function handleFlagItemClick(e) {
    var _this = this;

    var extension = this.props.extensionValue;
    var _state3 = this.state,
        selectedCountry = _state3.selectedCountry,
        formattedNumber = _state3.formattedNumber;

    var nextSelectedCountry = allCountries[iso2Lookup[e.target.value]];

    if (selectedCountry.iso2 !== nextSelectedCountry.iso2) {
      var newNumber = selectedCountry.dialCode ? formattedNumber.replace(/\D/g, '').replace(selectedCountry.dialCode, nextSelectedCountry.dialCode) : '' + nextSelectedCountry.dialCode + formattedNumber;

      var newFormattedNumber = (0, _formatPhoneNumber2.default)(newNumber, nextSelectedCountry.format);

      this.setState({
        selectedCountry: nextSelectedCountry,
        formattedNumber: newFormattedNumber
      }, function () {
        _this._cursorToEnd();
        if (_this.props.onChange) {
          _this.props.onChange({
            phoneNumber: _this.formatSimpleNumber(newNumber, selectedCountry.dialCode || nextSelectedCountry.dialCode),
            extension: extension,
            country: nextSelectedCountry.iso2
          });
        }
      });
    }
  },
  _mapPropsToState: function _mapPropsToState(props) {
    var inputNumber = void 0;
    if (props.value) {
      inputNumber = props.value;
    } else {
      inputNumber = '';
    }

    var selectedCountryGuess = INVALID_OPTION;
    var formattedNumber = inputNumber;
    if (inputNumber === '' || inputNumber.indexOf('+') === 0) {
      selectedCountryGuess = (0, _guessCountryFromDialCode2.default)(inputNumber.replace(/\D/g, ''));
      var numberToFormat = inputNumber ? inputNumber.replace(/\D/g, '') : selectedCountryGuess.dialCode;
      formattedNumber = (0, _formatPhoneNumber2.default)(numberToFormat, selectedCountryGuess.format);
    }

    return {
      selectedCountry: selectedCountryGuess,
      formattedNumber: formattedNumber
    };
  },
  getCountryDropDownList: function getCountryDropDownList(hasSelectedValidCountry, validCountries, supportedCountrySet) {
    var countryDropDownList = (0, _getPhoneOptions2.default)(allCountries);
    var checkSupportedCountries = function checkSupportedCountries(country) {
      return _SupportedPhoneNumbers2.default[supportedCountrySet].indexOf(country.value) >= 0;
    };
    var checkValidCountries = function checkValidCountries(country) {
      return validCountries.indexOf(country.value) >= 0;
    };

    if (supportedCountrySet && validCountries) {
      countryDropDownList = countryDropDownList.filter(function (country) {
        return checkSupportedCountries(country) && checkValidCountries(country);
      });
    } else if (supportedCountrySet) {
      countryDropDownList = countryDropDownList.filter(checkSupportedCountries);
    } else if (validCountries) {
      countryDropDownList = countryDropDownList.filter(checkValidCountries);
    }

    if (!hasSelectedValidCountry) {
      return [{
        value: INVALID_OPTION.iso2,
        text: _I18n2.default.text('i18nAddon.countryInfo.invalidCountryOption')
      }].concat(_toConsumableArray(countryDropDownList));
    }

    return countryDropDownList;
  },
  buildValueRenderer: function buildValueRenderer(countryIso) {
    return function () {
      if (!countryIso) {
        return _react2.default.createElement(_UIIcon2.default, { name: 'warning' });
      }

      return _react2.default.createElement(_CountryFlag2.default, { countryCode: countryIso });
    };
  },
  renderExtension: function renderExtension(extensionValue, extensionInputProps) {
    if (typeof extensionValue !== 'string') {
      return null;
    }

    return _react2.default.createElement(_UITextInput2.default, _extends({}, extensionInputProps, {
      className: (0, _classNames2.default)('extension-input', extensionInputProps.className),
      placeholder: _I18n2.default.text('i18nAddon.phoneNumberInput.extensionPlaceholder'),
      onChange: this.handleExtensionInput,
      value: extensionValue
    }));
  },
  render: function render() {
    var _this2 = this;

    var _state4 = this.state,
        selectedCountry = _state4.selectedCountry,
        formattedNumber = _state4.formattedNumber;

    var _props = this.props,
        className = _props.className,
        countrySelectProps = _props.countrySelectProps,
        extensionInputProps = _props.extensionInputProps,
        extensionValue = _props.extensionValue,
        phoneInputProps = _props.phoneInputProps,
        __onChange = _props.onChange,
        validCountries = _props.validCountries,
        supportedCountrySet = _props.supportedCountrySet,
        passThroughProps = _objectWithoutProperties(_props, ['className', 'countrySelectProps', 'extensionInputProps', 'extensionValue', 'phoneInputProps', 'onChange', 'validCountries', 'supportedCountrySet']);

    return _react2.default.createElement(
      'div',
      _extends({}, passThroughProps, {
        className: (0, _classNames2.default)('phone-number-input', className)
      }),
      _react2.default.createElement(_UISelect2.default, _extends({}, countrySelectProps, {
        className: (0, _classNames2.default)('country-select', countrySelectProps.className),
        dropdownClassName: (0, _classNames2.default)('country-dropdown', countrySelectProps.dropdownClassName),
        onChange: this.handleFlagItemClick,
        options: this.getCountryDropDownList(selectedCountry.dialCode, validCountries, supportedCountrySet),
        value: selectedCountry.iso2,
        valueRenderer: this.buildValueRenderer(selectedCountry.iso2)
      })),
      _react2.default.createElement(_UITextInput2.default, _extends({}, phoneInputProps, {
        className: (0, _classNames2.default)('phone-text-input', phoneInputProps.className),
        onChange: this.handlePhoneNumberInput,
        ref: function ref(input) {
          _this2.numberInput = input;
        },
        value: formattedNumber
      })),
      this.renderExtension(extensionValue, extensionInputProps)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/components/PhoneNumberInput.js
// module id = 555
// module chunks = 3 4 5